import React from 'react';
import { ActivityList } from './components/ActivityList';

const ActivityLog = () => {
  return (
    <div className="py-4 w-full max-w-screen-lg mx-auto">
      <div className="w-full md:w-2/3">
        <div className="py-6 px-4 rounded-md bg-white border border-neutral-200 shadow-sm">
          <ActivityList showLoading />
        </div>
      </div>
    </div>
  );
};

export default ActivityLog;
